import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { MenuModel } from '../models/menu.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private apiUrl = environment.apiUrl + 'Menu/GetMenu';

  constructor(private http: HttpClient) { }

  getMenu(): Observable<MenuModel[]> {
    const url = `${this.apiUrl}`;
      console.log(this.http.get<MenuModel[]>(url));
    return this.http.get<MenuModel[]>(url)
      .pipe(
        catchError((error: any) => {
          console.error('Error fetching menu:', error);
          throw error; // Rilancia l'errore per gestirlo nel chiamante
        })
      );

  }
}
